import { defineStore, storeToRefs } from "pinia";
import {computed, ref} from "vue";
import {useOrganisationSettingStore} from "@stores/OrganisationSettingStore";

export const useFeatureFlagStore = defineStore('featureFlageStore', () => {
    const organisationSettingStore = useOrganisationSettingStore();
    const { organisationSettings } = storeToRefs(organisationSettingStore);
    const { organisationSettingCachedValue } = organisationSettingStore;

    organisationSettingStore.sync();

    const isMainRegionFeatureEnabled = computed<boolean>(() => {
        return Boolean(Number(organisationSettingCachedValue("enable_main_region_feature")));
    });

    return {
        isMainRegionFeatureEnabled
    }
});
